import { Checkbox, type CheckboxProps } from 'antd';
import type { ReactNode } from 'react';
import cn from 'classnames';
import styles from './checkbox.module.scss';

type Props = CheckboxProps & {
    size?: 'md' | 'lg';
    label?: ReactNode;
};

export const AppCheckbox = ({
    className,
    size = 'lg',
    title,
    label,
    children,
    ...rest
}: Props) => {
    const content = label ?? title ?? children;

    return (
        <Checkbox
            {...rest}
            className={cn('app-checkbox', className)}
            rootClassName={cn(styles.root, styles[size])}
        >
            {content}
        </Checkbox>
    );
};
